// Services
import { HttpService } from "@mgs/ci2019-common/src/services/HttpService";

// Store
import { Store } from "#/store";

// Model
import { Warenkorb } from "#/common/interfaces/Warenkorb";

export class WarenkorbService {
  private static _instance;

  public static get instance() {
    if (!this._instance) {
      this._instance = new WarenkorbService();
    }
    return this._instance;
  }

  private constructor() {}

  private readonly http: HttpService = HttpService.instance;

  public async getAktuellerWarenkorb(): Promise<Warenkorb> {
    let url = Store.instance.ui.warenkorbApiUrl + `aktueller-warenkorb`;
    const response = await this.http.get<Warenkorb>(url);

    return response.body!;
  }

  public async updateAktuellerWarenkorb(biid, amount): Promise<Warenkorb> {
    let url = Store.instance.ui.warenkorbApiUrl + `aktueller-warenkorb/update`;
    const response = await this.http.put<Warenkorb>(url, { biid, amount });

    return response.body!;
  }

  public async aktuellenWarenkorbLeeren(): Promise<Warenkorb> {
    let url = Store.instance.ui.warenkorbApiUrl + `aktueller-warenkorb/empty`;
    const response = await this.http.put<Warenkorb>(url);

    return response.body!;
  }
}
